import * as React from "react";
import RaisedButton from "material-ui/RaisedButton";
import IconPlayCircleOutline from "material-ui/svg-icons/av/play-circle-outline";

import l10n = require("diy/util/l10n");

import {OpacityAnimation} from './../../../overlay/components/Animation';
import {Vimeo} from "./../../../components/Vimeo";

export interface StepVimeoProps {
    videoId: string;
    frameId: string;
}

interface StepVimeoState {
    isPlaying: boolean;
}

export class StepVimeo extends React.Component<StepVimeoProps, StepVimeoState> {

    constructor(props: StepVimeoProps, context: any) {
        super(props, context);
        this.state = {
            isPlaying: false
        };
    };

    render() {
        const styles = this.getStyles();

        return (
            <div style={styles.root} className="step-vimeo">
                <div style={styles.playButtonWrapper}
                     className="step-vimeo-control" >
                    <RaisedButton
                        onClick={this.playVideo}
                        label={l10n.getString('onboardingGuide.step.playVideo')}
                        icon={<IconPlayCircleOutline />}
                    />
                </div>
                { this.state.isPlaying ?
                <OpacityAnimation duration={2.5} fadeIn={true} fadeOut={true}>
                    <div style={styles.videoWrapper} className="step-vimeo-container">
                        <Vimeo videoId={this.props.videoId} frameId={this.props.frameId}
                               autoplay={this.state.isPlaying} onFinish={this.finishCallback} />
                    </div>
                </OpacityAnimation> : null }
            </div>
        );
    }

    componentWillUpdate(nextProps: StepVimeoProps) {
        if (this.state.isPlaying === true && this.props.videoId !== nextProps.videoId) {
            this.setState({isPlaying: false} as StepVimeoState);
        }
    }

    private playVideo = () => {
        this.setState({isPlaying: true} as StepVimeoState);
    }

    private finishCallback = () => {
        this.setState({isPlaying: false} as StepVimeoState);
    }

    private getStyles() {
        return {
            root: {
                position: "absolute"
            },
            playButtonWrapper: {
                margin: "8px 0 0 8px"
            },
            videoWrapper: {
                position: "absolute",
                top: "0",
                left: "0"
            }
        };
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/onboarding-guide/components/StepVimeo.tsx
 **/